module.exports = "./img/4b7266819e43f07e5bffbf53cab7f6d0.png";